import React, { useContext, useEffect, useState } from 'react'
import { DomainContext } from '../../../../context/DomainContext';

export const useGenerateSearchFields = (columns) => {

    const [hiddenColumnsList, setHiddenColumnsList] = useState();
    const {setSearchTypes , setSearchData} =useContext(DomainContext)

    useEffect(() => {
        let searchFields = {};
        let customSearch = {};
        let hiddenColumns = [];

        columns.forEach((element) => {
            if (element?.canSearch && !element?.type)
                searchFields[element.probName||element.accessor] = "";

            if (element?.canSearch && element?.type != null) {
                customSearch[element.accessor] = {
                    type: element?.type,
                    depArr: element?.depArr,
                    apiSource: element?.sourceApi,
                    isMulti: element?.isMulti,
                    isRequired: element?.isRequired,
                    Header: element?.Header,
                    accessor: element?.accessor,
                    options: element?.options,
                    probName: element?.probName,
                    sourceId: element?.sourceId,
                    defaultValue: element?.defaultValue,
                };
            }

            if (element["visible"] == false) {
                hiddenColumns.push(element["accessor"]);
            }
        });

        setHiddenColumnsList(hiddenColumns);
        setSearchTypes((prev) => customSearch);
        setSearchData((prev) => searchFields || {});
    }, []);

    return { hiddenColumnsList}
}
